import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const stepCircleCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    justify_content: 'center',
    align_items: 'center',
    border_radius: FOUNDATIONS.radius_1000,
    width: FOUNDATIONS.size_325,
    height: FOUNDATIONS.size_325,
    border_style: 'solid',
    border_width: FOUNDATIONS.border_100,
});
export const verticalCommonStyles = (FOUNDATIONS, FONT) => ({
    description_font_align: TEXT_ALIGN.left,
    iconSelected: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_comp_navigation_stepper_completed_icon,
    },
    stepContainer: {
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_150,
    },
    stepNameContainer: {
        padding_top: FOUNDATIONS.spacing_100,
    },
    stepIndex: {
        color: FOUNDATIONS.color_neutral_font_static_white,
        font_weight: FONT_WEIGHT.font_weight_600,
        font_variant: TextVariantType.FONT_PARAGRAPH_400,
    },
});
export const stepBarCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_38,
    height: FOUNDATIONS.size_200,
    margin_top: FOUNDATIONS.spacing_100,
});
//# sourceMappingURL=commonStyles.js.map